import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Printer, CheckCircle2, Loader2, CreditCard } from "lucide-react";
import { toast } from "sonner";
import { API, api, errMsg } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { InvoiceDocument } from "@/components/InvoiceDocument";
import { QuoteBadge } from "./Quotes";

export default function PublicQuote() {
  const { token } = useParams();
  const { t } = useLang();
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    fetch(`${API}/public/quotes/${token}`).then((r) => (r.ok ? r.json() : Promise.reject())).then(setData).catch(() => setErr(true));
  }, [token]);
  const accept = async () => {
    setBusy(true);
    try {
      const { data: d } = await api.post(`/public/quotes/${token}/accept`);
      toast.success(t("quoteAccepted"));
      nav(`/i/${d.invoice_token}`);
    } catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  const q = data?.quote;
  const open = q && !["converted", "declined"].includes(q.status);
  return (
    <div className="min-h-screen bg-[#F6F7F4] p-4 sm:p-10" data-testid="public-quote-page">
      <div className="no-print mx-auto mb-6 flex max-w-[820px] flex-wrap items-center gap-3">
        <Link to="/"><img src="/images/logo-compact-dark.png" alt="Mohassib" className="h-12 w-auto rounded-lg bg-[#04140B] px-2 py-1" /></Link>
        {q && <QuoteBadge status={q.status} />}
        <div className="ms-auto flex gap-2">
          {open && <button data-testid="public-quote-accept-btn" disabled={busy} onClick={accept} className="inline-flex items-center gap-2 rounded-full bg-[#007A3D] px-5 py-2 text-sm font-bold text-white hover:bg-[#005E2E] disabled:opacity-60">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <CheckCircle2 className="h-4 w-4" />}{t("acceptAndPay")}</button>}
          {q?.status === "converted" && data.invoice_token && <Link data-testid="public-quote-invoice-link" to={`/i/${data.invoice_token}`} className="inline-flex items-center gap-2 rounded-full bg-[#007A3D] px-5 py-2 text-sm font-bold text-white hover:bg-[#005E2E]"><CreditCard className="h-4 w-4" />{t("viewInvoice")}</Link>}
          {q && <button data-testid="public-quote-print-btn" onClick={() => window.print()} className="inline-flex items-center gap-2 rounded-full bg-[#0B1220] px-4 py-2 text-sm font-bold text-white hover:bg-slate-800"><Printer className="h-4 w-4" />{t("print")} / PDF</button>}
        </div>
      </div>
      {err && <p data-testid="public-quote-notfound" className="text-center text-slate-500">{t("noData")}</p>}
      {q && <InvoiceDocument inv={q} co={data.company} kind="quote" />}
    </div>
  );
}
